    import React from "react";
    import bannerImage from "../assets/images/Herosection/herobanner.jpg"; // change path if needed

    const PageBanner = ({ title, subtitle }) => {
    const brandGold = "#E3B66B";

    return (
        <section className="relative w-full h-[300px] md:h-[350px] lg:h-[400px] flex items-center justify-center font-serif overflow-hidden">

        {/* Background Image */}
        <div className="absolute inset-0">
            <img
            src={bannerImage}
            alt="Banner"
            className="w-full h-full object-cover"
            />

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/60"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6">

            {/* Subtitle */}
            {subtitle && (
            <p
                className="uppercase tracking-[0.3em] text-xs mb-4"
                style={{ color: brandGold }}
            >
                {subtitle}
            </p>
            )}

            {/* Title */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase tracking-wide">
            {title}
            </h1>

            {/* Gold Line */}
            <div
            className="w-24 h-[2px] mx-auto mt-4"
            style={{ backgroundColor: brandGold }}
            ></div>

        </div>

        {/* Watermark */}
        <div className="absolute lg:bottom-[-20px] md:bottom-[-10px] left-0 w-full text-center pointer-events-none select-none">
    <span className="text-[12vw] font-bold text-white/5 uppercase block">
         Justice
    </span>
    </div>


        </section>
    );
    };

    export default PageBanner;
